import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { requestErrorHandler } from 'utils';
import {
  FindOrCreateDriverActions,
  FindOrCreateDriverRequest,
} from 'store/ducks/drivers';

export function* findOrCreateDriverRequest(action: any) {
  const {
    postData,
    onDriverFound,
    onDriverNotFound,
    onFailure,
  }: FindOrCreateDriverRequest = action;

  try {
    const { data } = yield call(api.post, `/drivers/find-or-create`, postData);
    onDriverFound && onDriverFound(data);
    yield put(FindOrCreateDriverActions.success());
  } catch (error) {
    const { errorMessage, validationErrors, errorCode } =
      requestErrorHandler(error);

    /**
     * If the code is DRIVER_NOT_FOUND, then we ask for the driver birth date
     * to send it along the document to create and return a new driver
     */
    if (errorCode === 'DRIVER_NOT_FOUND') {
      notify('warning', errorMessage);
      onDriverNotFound && onDriverNotFound();
    } else {
      notify('error', errorMessage);
      onFailure && onFailure();
    }

    yield put(
      FindOrCreateDriverActions.failure(errorMessage, validationErrors)
    );
  }
}
